// i18n strings for the 88 Days Visa Checker feature
// Keep this in a separate file so we don't bloat the main i18n.js

export const visaDaysI18n = {
  en: {
    nav_label: "88 Days",
    title: "88 Days Visa Checker",
    subtitle: "Verify your work counts for your 2nd Year Working Holiday Visa.",
    back_to_app: "Back to AussieCV",
    overline: "88 DAYS · 2ND YEAR WHV",
    tabs: {
      checker: "Postcode Checker",
      map: "Eligible Zones Map",
      tracker: "My 88 Days Tracker",
    },
    checker: {
      title: "Check if your work counts",
      sub: "Enter your work postcode and industry — we'll tell you instantly if it counts toward your 88 days.",
      postcode_label: "Work postcode",
      postcode_ph: "e.g. 6714, 4805, 2680...",
      visa_label: "Your visa",
      industry_label: "Industry",
      check_btn: "Check eligibility",
      result_eligible: "Eligible for your 88 days",
      result_not_eligible: "Not eligible — won't count",
      reason_not_regional: "This postcode is in a major metro area — only regional postcodes count.",
      reason_not_northern: "Tourism / hospitality only counts in Northern Australia (above the Tropic of Capricorn) for 462 visa.",
      reason_industry_not_417: "This industry isn't eligible for the 417 visa.",
      reason_industry_not_462: "This industry isn't eligible for the 462 visa.",
      reason_invalid_postcode: "This postcode doesn't match any Australian state.",
      cta_seek: "Find jobs on Seek here",
      cta_harvest: "Open Harvest Trail",
    },
    map: {
      title: "Where can you work?",
      sub: "Green = eligible regional zones. Red = excluded metros. Click a marker for details.",
      legend_farm: "Farm work",
      legend_mining: "Mining / FIFO",
      legend_tourism: "Tourism (Northern AU — 462 only)",
      legend_metro: "Metro — NOT eligible",
    },
    tracker: {
      title: "My 88 Days Tracker",
      sub: "Upload your payslips OR add work periods manually. We auto-validate each one.",
      visa_select: "Which visa are you working toward?",
      target_select: "Target",
      target_88: "2nd WHV · 88 days",
      target_179: "3rd WHV · 179 days",
      upload_title: "Upload payslip (PDF)",
      upload_sub: "We extract dates, employer & location automatically. Files stay in your browser.",
      upload_btn: "Upload payslip",
      uploading: "Extracting data…",
      add_manual: "Or add a period manually",
      manual_employer: "Employer name",
      manual_postcode: "Work postcode",
      manual_industry: "Industry",
      manual_start: "Start date",
      manual_end: "End date",
      manual_add: "Add period",
      manual_contract: "Contract type",
      manual_days_worked: "Physical days worked",
      manual_days_worked_hint: "Count only days with a full shift. Not half-days.",
      manual_hours_worked: "Total hours on payslip",
      manual_hours_worked_hint: "Divided by 7h/day to compute equivalent days.",
      manual_days_per_week: "Days worked per week (per contract)",
      manual_days_per_week_hint: "5 days/week in a contract = 7 days counted (weekends included).",
      manual_hourly_rate: "Hourly rate ($/h)",
      manual_hourly_rate_hint: "Used to detect underpayment risk.",
      contract_casual_desc: "Physical days only",
      contract_part_time_desc: "Calculated from total hours",
      contract_piece_rate_desc: "Paid per kilo/bin — physical days only",
      contract_fulltime_desc: "Rest days included",
      empty_title: "No periods yet",
      empty_sub: "Upload a payslip or add a period manually to start tracking.",
      progress_label: "Total eligible days",
      progress_title: "Your 88 Days progress",
      progress_intro: "Only <b>validated</b> periods count towards your visa. Complete missing locations to unlock more days.",
      stat_validated: "Validated",
      stat_to_complete: "To complete",
      stat_rejected: "Rejected",
      stat_days: "days",
      remaining: "Remaining",
      complete: "You did it!",
      export_hint: "Download a PDF you can attach to your visa application. Include one payslip per period.",
      th_period: "Period",
      th_days: "Days",
      th_employer: "Employer",
      th_location: "Location",
      th_industry: "Industry",
      th_status: "Status",
      th_actions: "",
      delete: "Delete",
      eligible: "Eligible",
      not_eligible: "Not eligible",
      location_required: "Location required",
      choose_location: "Choose location",
      change_location: "Change location",
      location_missing_hint: "Search a city, postcode or region",
      export_btn: "Export proof PDF (for Immigration)",
      payslip_parsed: "Payslip parsed successfully",
      payslip_error: "Could not read this payslip. Try another PDF or add manually.",
      payslip_missing_postcode: "Could not detect a postcode. Please confirm:",
      wage_warning_title: "Underpayment detected",
      wage_warning_body: "You declared ${rate}/h but the legal minimum is ${minimum}/h. Underpaid work can cause visa refusal — check your Award and your employer.",
      rules_title: "Official counting rules",
      rules_link: "How does Immigration count my days?",
    },
  },
  fr: {
    nav_label: "88 Jours",
    title: "Validateur 88 Jours",
    subtitle: "Vérifie que ton travail compte pour le visa 2ème année WHV.",
    back_to_app: "Retour à AussieCV",
    overline: "88 JOURS · 2E ANNÉE WHV",
    tabs: {
      checker: "Vérif postcode",
      map: "Carte des zones",
      tracker: "Mon tracker 88 jours",
    },
    checker: {
      title: "Vérifie si ton boulot compte",
      sub: "Entre ton code postal de travail et ton industrie — on te dit instantanément s'il compte pour tes 88 jours.",
      postcode_label: "Code postal du travail",
      postcode_ph: "ex. 6714, 4805, 2680...",
      visa_label: "Ton visa",
      industry_label: "Industrie",
      check_btn: "Vérifier l'éligibilité",
      result_eligible: "Éligible pour tes 88 jours",
      result_not_eligible: "Non éligible — ne comptera pas",
      reason_not_regional: "Ce code postal est dans une métropole — seuls les codes régionaux comptent.",
      reason_not_northern: "Tourisme / hôtellerie ne compte qu'en Northern Australia (au-dessus du Tropique du Capricorne) pour le visa 462.",
      reason_industry_not_417: "Cette industrie n'est pas éligible pour le visa 417.",
      reason_industry_not_462: "Cette industrie n'est pas éligible pour le visa 462.",
      reason_invalid_postcode: "Ce code postal ne correspond à aucun état australien.",
      cta_seek: "Trouver des jobs sur Seek",
      cta_harvest: "Ouvrir Harvest Trail",
    },
    map: {
      title: "Où peux-tu travailler ?",
      sub: "Vert = zones régionales éligibles. Rouge = métropoles exclues. Clique sur un point pour les détails.",
      legend_farm: "Ferme",
      legend_mining: "Mines / FIFO",
      legend_tourism: "Tourisme (Nord AU — 462 uniquement)",
      legend_metro: "Métropole — NON éligible",
    },
    tracker: {
      title: "Mon tracker 88 jours",
      sub: "Importe tes fiches de paie OU ajoute des périodes à la main. On valide tout automatiquement.",
      visa_select: "Pour quel visa tu bosses ?",
      target_select: "Objectif",
      target_88: "2ème WHV · 88 jours",
      target_179: "3ème WHV · 179 jours",
      upload_title: "Importer une fiche de paie (PDF)",
      upload_sub: "On extrait dates, employeur et lieu automatiquement. Les fichiers restent dans ton navigateur.",
      upload_btn: "Importer une fiche",
      uploading: "Extraction des données…",
      add_manual: "Ou ajoute une période à la main",
      manual_employer: "Nom de l'employeur",
      manual_postcode: "Code postal du lieu",
      manual_industry: "Industrie",
      manual_start: "Date de début",
      manual_end: "Date de fin",
      manual_add: "Ajouter la période",
      manual_contract: "Type de contrat",
      manual_days_worked: "Jours physiquement travaillés",
      manual_days_worked_hint: "Compte uniquement les jours avec un shift complet. Pas les demi-journées.",
      manual_hours_worked: "Heures totales sur la fiche",
      manual_hours_worked_hint: "Divisées par 7h → nombre de jours équivalents.",
      manual_days_per_week: "Jours travaillés par semaine (contrat)",
      manual_days_per_week_hint: "5 jours/sem en contrat = 7 jours comptés (week-end inclus).",
      manual_hourly_rate: "Taux horaire ($/h)",
      manual_hourly_rate_hint: "Utilisé pour détecter le sous-paiement.",
      contract_casual_desc: "Jours physiques uniquement",
      contract_part_time_desc: "Calcul via heures totales",
      contract_piece_rate_desc: "Payé au kilo/bin — jours physiques",
      contract_fulltime_desc: "Jours de repos inclus",
      empty_title: "Aucune période pour l'instant",
      empty_sub: "Importe une fiche de paie ou ajoute une période manuellement.",
      progress_label: "Jours éligibles cumulés",
      progress_title: "Ta progression 88 jours",
      progress_intro: "Seules les périodes <b>validées</b> comptent pour ton visa. Complète les lieux manquants pour débloquer plus de jours.",
      stat_validated: "Validées",
      stat_to_complete: "À compléter",
      stat_rejected: "Rejetées",
      stat_days: "jours",
      remaining: "Restants",
      complete: "Bravo !",
      export_hint: "Télécharge un PDF à joindre à ta demande de visa. Ajoute une fiche de paie par période.",
      th_period: "Période",
      th_days: "Jours",
      th_employer: "Employeur",
      th_location: "Lieu",
      th_industry: "Industrie",
      th_status: "Statut",
      th_actions: "",
      delete: "Supprimer",
      eligible: "Éligible",
      not_eligible: "Non éligible",
      location_required: "Lieu requis",
      choose_location: "Choisir le lieu",
      change_location: "Modifier le lieu",
      location_missing_hint: "Recherche une ville, un code postal ou une région",
      export_btn: "Exporter le dossier preuve (pour Immigration)",
      payslip_parsed: "Fiche de paie analysée avec succès",
      payslip_error: "Impossible de lire cette fiche. Essaie un autre PDF ou ajoute à la main.",
      payslip_missing_postcode: "Code postal non détecté. Merci de confirmer :",
      wage_warning_title: "Sous-paiement détecté",
      wage_warning_body: "Tu as déclaré ${rate}/h alors que le minimum légal est ${minimum}/h. Un travail sous-payé peut causer un refus de visa — vérifie ton Award et ton employeur.",
      rules_title: "Règles officielles de calcul",
      rules_link: "Comment l'Immigration compte mes jours ?",
    },
  },
  de: {
    nav_label: "88 Tage",
    title: "88-Tage-Visum-Checker",
    subtitle: "Prüfe, ob deine Arbeit für dein 2. WHV zählt.",
    tabs: { checker: "PLZ-Prüfer", map: "Berechtigte Zonen", tracker: "Mein 88-Tage-Tracker" },
    checker: {
      title: "Prüfe, ob deine Arbeit zählt",
      sub: "Gib deine Arbeitsplatz-PLZ und Branche ein — wir sagen dir sofort, ob es für deine 88 Tage zählt.",
      postcode_label: "Arbeitsort-PLZ",
      postcode_ph: "z.B. 6714, 4805, 2680...",
      visa_label: "Dein Visum",
      industry_label: "Branche",
      check_btn: "Berechtigung prüfen",
      result_eligible: "Berechtigt für deine 88 Tage",
      result_not_eligible: "Nicht berechtigt — zählt nicht",
      reason_not_regional: "Diese PLZ liegt in einem Großstadtgebiet — nur regionale PLZ zählen.",
      reason_not_northern: "Tourismus / Gastgewerbe zählt nur in Nord-Australien (über dem Wendekreis) für das 462-Visum.",
      reason_industry_not_417: "Diese Branche ist für das 417-Visum nicht berechtigt.",
      reason_industry_not_462: "Diese Branche ist für das 462-Visum nicht berechtigt.",
      reason_invalid_postcode: "Diese PLZ stimmt mit keinem australischen Bundesstaat überein.",
      cta_seek: "Jobs auf Seek finden",
      cta_harvest: "Harvest Trail öffnen",
    },
    map: {
      title: "Wo kannst du arbeiten?",
      sub: "Grün = berechtigte Regionalzonen. Rot = ausgeschlossene Großstädte. Klick auf einen Marker für Details.",
      legend_farm: "Farmarbeit",
      legend_mining: "Bergbau / FIFO",
      legend_tourism: "Tourismus (Nord-AU — nur 462)",
      legend_metro: "Metropole — NICHT berechtigt",
    },
    tracker: {
      title: "Mein 88-Tage-Tracker",
      sub: "Lade deine Lohnabrechnungen hoch ODER füge Arbeitsperioden manuell hinzu. Wir validieren automatisch.",
      visa_select: "Auf welches Visum arbeitest du hin?",
      target_select: "Ziel",
      target_88: "2. WHV · 88 Tage",
      target_179: "3. WHV · 179 Tage",
      upload_title: "Lohnabrechnung hochladen (PDF)",
      upload_sub: "Wir extrahieren Daten, Arbeitgeber & Ort automatisch. Dateien bleiben in deinem Browser.",
      upload_btn: "Lohnabrechnung hochladen",
      uploading: "Daten extrahieren…",
      add_manual: "Oder Periode manuell hinzufügen",
      manual_employer: "Name des Arbeitgebers",
      manual_postcode: "Arbeitsort-PLZ",
      manual_industry: "Branche",
      manual_start: "Startdatum",
      manual_end: "Enddatum",
      manual_add: "Periode hinzufügen",
      manual_contract: "Vertragsart",
      manual_days_worked: "Physisch gearbeitete Tage",
      manual_days_worked_hint: "Zähle nur Tage mit einer vollen Schicht. Keine halben Tage.",
      manual_hours_worked: "Gesamtstunden auf der Lohnabrechnung",
      manual_hours_worked_hint: "Geteilt durch 7h/Tag zur Berechnung der Tage.",
      manual_days_per_week: "Arbeitstage pro Woche (laut Vertrag)",
      manual_days_per_week_hint: "5 Tage/Woche im Vertrag = 7 Tage gezählt (Wochenenden inklusive).",
      manual_hourly_rate: "Stundensatz ($/h)",
      manual_hourly_rate_hint: "Zur Erkennung von Unterbezahlung.",
      contract_casual_desc: "Nur physische Tage",
      contract_part_time_desc: "Berechnet aus Gesamtstunden",
      contract_piece_rate_desc: "Bezahlt pro Kilo/Kiste — nur physische Tage",
      contract_fulltime_desc: "Ruhetage inklusive",
      empty_title: "Noch keine Perioden",
      empty_sub: "Lade eine Lohnabrechnung hoch oder füge eine Periode manuell hinzu.",
      progress_label: "Gesamte berechtigte Tage",
      progress_title: "Dein 88-Tage-Fortschritt",
      progress_intro: "Nur <b>validierte</b> Perioden zählen für dein Visum. Vervollständige fehlende Orte, um mehr Tage freizuschalten.",
      stat_validated: "Validiert",
      stat_to_complete: "Zu vervollst.",
      stat_rejected: "Abgelehnt",
      stat_days: "Tage",
      remaining: "Verbleibend",
      complete: "Geschafft!",
      export_hint: "Lade ein PDF herunter, das du deinem Visumantrag beifügen kannst. Füge einen Lohnzettel pro Periode hinzu.",
      th_period: "Periode",
      th_days: "Tage",
      th_employer: "Arbeitgeber",
      th_location: "Ort",
      th_industry: "Branche",
      th_status: "Status",
      th_actions: "",
      delete: "Löschen",
      eligible: "Berechtigt",
      not_eligible: "Nicht berechtigt",
      location_required: "Ort erforderlich",
      choose_location: "Ort auswählen",
      change_location: "Ort ändern",
      location_missing_hint: "Suche eine Stadt, PLZ oder Region",
      export_btn: "Beweis-PDF exportieren (für Immigration)",
      payslip_parsed: "Lohnabrechnung erfolgreich analysiert",
      payslip_error: "Konnte diese Lohnabrechnung nicht lesen. Versuche ein anderes PDF oder füge manuell hinzu.",
      payslip_missing_postcode: "PLZ nicht erkannt. Bitte bestätigen:",
      wage_warning_title: "Unterbezahlung erkannt",
      wage_warning_body: "Du hast ${rate}/h angegeben, der gesetzliche Mindestlohn ist ${minimum}/h. Unterbezahlte Arbeit kann zu einer Visumablehnung führen — prüfe deinen Award und deinen Arbeitgeber.",
      rules_title: "Offizielle Berechnungsregeln",
      rules_link: "Wie zählt Immigration meine Tage?",
    },
  },
  it: {
    nav_label: "88 Giorni",
    title: "Calcolatore 88 Giorni",
    subtitle: "Verifica se il tuo lavoro conta per il 2° WHV.",
    back_to_app: "Torna ad AussieCV",
    overline: "88 GIORNI · 2° ANNO WHV",
    tabs: { checker: "Verifica CAP", map: "Mappa zone", tracker: "Il mio tracker 88 giorni" },
    checker: {
      title: "Verifica se il tuo lavoro conta",
      sub: "Inserisci il CAP del lavoro e il settore — ti diciamo subito se conta per i tuoi 88 giorni.",
      postcode_label: "CAP del lavoro",
      postcode_ph: "es. 6714, 4805, 2680...",
      visa_label: "Il tuo visto",
      industry_label: "Settore",
      check_btn: "Verifica idoneità",
      result_eligible: "Idoneo per i tuoi 88 giorni",
      result_not_eligible: "Non idoneo — non conta",
      reason_not_regional: "Questo CAP è in un'area metropolitana — contano solo i CAP regionali.",
      reason_not_northern: "Turismo / ospitalità conta solo nel Nord Australia (sopra il Tropico) per il visto 462.",
      reason_industry_not_417: "Questo settore non è idoneo per il visto 417.",
      reason_industry_not_462: "Questo settore non è idoneo per il visto 462.",
      reason_invalid_postcode: "Questo CAP non corrisponde a nessuno stato australiano.",
      cta_seek: "Trova lavori su Seek",
      cta_harvest: "Apri Harvest Trail",
    },
    map: {
      title: "Dove puoi lavorare?",
      sub: "Verde = zone regionali idonee. Rosso = metropoli escluse. Clicca un marker per i dettagli.",
      legend_farm: "Lavoro in fattoria",
      legend_mining: "Miniere / FIFO",
      legend_tourism: "Turismo (Nord AU — solo 462)",
      legend_metro: "Metropoli — NON idonea",
    },
    tracker: {
      title: "Il mio tracker 88 giorni",
      sub: "Carica le buste paga O aggiungi periodi manualmente. Validazione automatica.",
      visa_select: "Per quale visto stai lavorando?",
      target_select: "Obiettivo",
      target_88: "2° WHV · 88 giorni",
      target_179: "3° WHV · 179 giorni",
      upload_title: "Carica busta paga (PDF)",
      upload_sub: "Estraiamo date, datore di lavoro e luogo automaticamente. I file restano nel tuo browser.",
      upload_btn: "Carica busta paga",
      uploading: "Estrazione dati…",
      add_manual: "Oppure aggiungi un periodo manualmente",
      manual_employer: "Nome del datore di lavoro",
      manual_postcode: "CAP del luogo di lavoro",
      manual_industry: "Settore",
      manual_start: "Data inizio",
      manual_end: "Data fine",
      manual_add: "Aggiungi periodo",
      manual_contract: "Tipo di contratto",
      manual_days_worked: "Giorni fisicamente lavorati",
      manual_days_worked_hint: "Conta solo i giorni con un turno completo. Niente mezze giornate.",
      manual_hours_worked: "Ore totali sulla busta paga",
      manual_hours_worked_hint: "Diviso per 7h/giorno per calcolare i giorni equivalenti.",
      manual_days_per_week: "Giorni lavorati per settimana (da contratto)",
      manual_days_per_week_hint: "5 giorni/settimana nel contratto = 7 giorni contati (weekend inclusi).",
      manual_hourly_rate: "Tariffa oraria ($/h)",
      manual_hourly_rate_hint: "Usata per rilevare sottopagamento.",
      contract_casual_desc: "Solo giorni fisici",
      contract_part_time_desc: "Calcolato dalle ore totali",
      contract_piece_rate_desc: "Pagato a kg/bidone — solo giorni fisici",
      contract_fulltime_desc: "Giorni di riposo inclusi",
      empty_title: "Nessun periodo ancora",
      empty_sub: "Carica una busta paga o aggiungi un periodo manualmente.",
      progress_label: "Giorni idonei totali",
      progress_title: "I tuoi progressi 88 giorni",
      progress_intro: "Solo i periodi <b>validati</b> contano per il tuo visto. Completa i luoghi mancanti per sbloccare più giorni.",
      stat_validated: "Validati",
      stat_to_complete: "Da completare",
      stat_rejected: "Rifiutati",
      stat_days: "giorni",
      remaining: "Rimanenti",
      complete: "Ce l'hai fatta!",
      export_hint: "Scarica un PDF da allegare alla tua domanda di visto. Aggiungi una busta paga per periodo.",
      th_period: "Periodo",
      th_days: "Giorni",
      th_employer: "Datore di lavoro",
      th_location: "Luogo",
      th_industry: "Settore",
      th_status: "Stato",
      th_actions: "",
      delete: "Elimina",
      eligible: "Idoneo",
      not_eligible: "Non idoneo",
      location_required: "Luogo richiesto",
      choose_location: "Scegli il luogo",
      change_location: "Modifica il luogo",
      location_missing_hint: "Cerca una città, codice postale o regione",
      export_btn: "Esporta PDF di prova (per Immigration)",
      payslip_parsed: "Busta paga analizzata con successo",
      payslip_error: "Impossibile leggere questa busta paga. Prova un altro PDF o aggiungi manualmente.",
      payslip_missing_postcode: "CAP non rilevato. Per favore conferma:",
      wage_warning_title: "Sottopagamento rilevato",
      wage_warning_body: "Hai dichiarato ${rate}/h ma il minimo legale è ${minimum}/h. Il lavoro sottopagato può causare il rifiuto del visto — controlla il tuo Award e il datore di lavoro.",
      rules_title: "Regole ufficiali di calcolo",
      rules_link: "Come conta i giorni Immigration?",
    },
  },
  es: {
    nav_label: "88 Días",
    title: "Calculadora 88 Días",
    subtitle: "Verifica si tu trabajo cuenta para tu 2° WHV.",
    back_to_app: "Volver a AussieCV",
    overline: "88 DÍAS · 2° AÑO WHV",
    tabs: { checker: "Verificador CP", map: "Mapa zonas", tracker: "Mi tracker 88 días" },
    checker: {
      title: "Verifica si tu trabajo cuenta",
      sub: "Introduce el código postal de trabajo y la industria — te decimos al instante si cuenta para tus 88 días.",
      postcode_label: "Código postal de trabajo",
      postcode_ph: "ej. 6714, 4805, 2680...",
      visa_label: "Tu visa",
      industry_label: "Industria",
      check_btn: "Verificar elegibilidad",
      result_eligible: "Elegible para tus 88 días",
      result_not_eligible: "No elegible — no contará",
      reason_not_regional: "Este código postal está en una zona metropolitana — solo cuentan los códigos regionales.",
      reason_not_northern: "Turismo / hostelería solo cuenta en el Norte de Australia (sobre el Trópico) para visa 462.",
      reason_industry_not_417: "Esta industria no es elegible para la visa 417.",
      reason_industry_not_462: "Esta industria no es elegible para la visa 462.",
      reason_invalid_postcode: "Este código postal no corresponde a ningún estado australiano.",
      cta_seek: "Buscar empleos en Seek",
      cta_harvest: "Abrir Harvest Trail",
    },
    map: {
      title: "¿Dónde puedes trabajar?",
      sub: "Verde = zonas regionales elegibles. Rojo = metrópolis excluidas. Haz clic en un marcador para detalles.",
      legend_farm: "Trabajo agrícola",
      legend_mining: "Minería / FIFO",
      legend_tourism: "Turismo (Norte AU — solo 462)",
      legend_metro: "Metrópoli — NO elegible",
    },
    tracker: {
      title: "Mi tracker 88 días",
      sub: "Sube tus nóminas O añade periodos manualmente. Validamos cada uno automáticamente.",
      visa_select: "¿Para qué visa estás trabajando?",
      target_select: "Objetivo",
      target_88: "2ª WHV · 88 días",
      target_179: "3ª WHV · 179 días",
      upload_title: "Subir nómina (PDF)",
      upload_sub: "Extraemos fechas, empleador y ubicación automáticamente. Los archivos quedan en tu navegador.",
      upload_btn: "Subir nómina",
      uploading: "Extrayendo datos…",
      add_manual: "O añade un periodo manualmente",
      manual_employer: "Nombre del empleador",
      manual_postcode: "Código postal del trabajo",
      manual_industry: "Industria",
      manual_start: "Fecha inicio",
      manual_end: "Fecha fin",
      manual_add: "Añadir periodo",
      manual_contract: "Tipo de contrato",
      manual_days_worked: "Días físicamente trabajados",
      manual_days_worked_hint: "Cuenta solo los días con turno completo. No medios días.",
      manual_hours_worked: "Horas totales en la nómina",
      manual_hours_worked_hint: "Divididas por 7h/día para calcular días equivalentes.",
      manual_days_per_week: "Días trabajados por semana (según contrato)",
      manual_days_per_week_hint: "5 días/semana en contrato = 7 días contados (fin de semana incluido).",
      manual_hourly_rate: "Tarifa por hora ($/h)",
      manual_hourly_rate_hint: "Usada para detectar pago insuficiente.",
      contract_casual_desc: "Solo días físicos",
      contract_part_time_desc: "Calculado desde horas totales",
      contract_piece_rate_desc: "Pagado por kilo/cajón — solo días físicos",
      contract_fulltime_desc: "Días de descanso incluidos",
      empty_title: "Sin periodos aún",
      empty_sub: "Sube una nómina o añade un periodo manualmente.",
      progress_label: "Días elegibles totales",
      progress_title: "Tu progreso de 88 días",
      progress_intro: "Solo los periodos <b>validados</b> cuentan para tu visado. Completa las ubicaciones faltantes para desbloquear más días.",
      stat_validated: "Validados",
      stat_to_complete: "Por completar",
      stat_rejected: "Rechazados",
      stat_days: "días",
      remaining: "Restantes",
      complete: "¡Lo lograste!",
      export_hint: "Descarga un PDF para adjuntar a tu solicitud de visado. Añade una nómina por periodo.",
      th_period: "Periodo",
      th_days: "Días",
      th_employer: "Empleador",
      th_location: "Ubicación",
      th_industry: "Industria",
      th_status: "Estado",
      th_actions: "",
      delete: "Eliminar",
      eligible: "Elegible",
      not_eligible: "No elegible",
      location_required: "Ubicación requerida",
      choose_location: "Elegir ubicación",
      change_location: "Cambiar ubicación",
      location_missing_hint: "Busca una ciudad, código postal o región",
      export_btn: "Exportar PDF de prueba (para Inmigración)",
      payslip_parsed: "Nómina analizada con éxito",
      payslip_error: "No se pudo leer esta nómina. Prueba otro PDF o añade manualmente.",
      payslip_missing_postcode: "Código postal no detectado. Por favor confirma:",
      wage_warning_title: "Pago insuficiente detectado",
      wage_warning_body: "Declaraste ${rate}/h pero el mínimo legal es ${minimum}/h. El trabajo mal pagado puede causar rechazo de visa — revisa tu Award y a tu empleador.",
      rules_title: "Reglas oficiales de cálculo",
      rules_link: "¿Cómo cuenta Inmigración mis días?",
    },
  },
  pt: {
    nav_label: "88 Dias",
    title: "Calculadora 88 Dias",
    subtitle: "Verifica se o teu trabalho conta para o teu 2° WHV.",
    back_to_app: "Voltar ao AussieCV",
    overline: "88 DIAS · 2° ANO WHV",
    tabs: { checker: "Verificador CP", map: "Mapa zonas", tracker: "O meu tracker 88 dias" },
    checker: {
      title: "Verifica se o teu trabalho conta",
      sub: "Introduz o código postal do trabalho e a indústria — dizemos-te logo se conta para os teus 88 dias.",
      postcode_label: "Código postal do trabalho",
      postcode_ph: "ex. 6714, 4805, 2680...",
      visa_label: "O teu visto",
      industry_label: "Indústria",
      check_btn: "Verificar elegibilidade",
      result_eligible: "Elegível para os teus 88 dias",
      result_not_eligible: "Não elegível — não vai contar",
      reason_not_regional: "Este código postal está numa área metropolitana — só códigos regionais contam.",
      reason_not_northern: "Turismo / hotelaria só conta no Norte da Austrália (acima do Trópico) para visto 462.",
      reason_industry_not_417: "Esta indústria não é elegível para o visto 417.",
      reason_industry_not_462: "Esta indústria não é elegível para o visto 462.",
      reason_invalid_postcode: "Este código postal não corresponde a nenhum estado australiano.",
      cta_seek: "Procurar empregos no Seek",
      cta_harvest: "Abrir Harvest Trail",
    },
    map: {
      title: "Onde podes trabalhar?",
      sub: "Verde = zonas regionais elegíveis. Vermelho = metrópoles excluídas. Clica num marcador para detalhes.",
      legend_farm: "Trabalho agrícola",
      legend_mining: "Mineração / FIFO",
      legend_tourism: "Turismo (Norte AU — só 462)",
      legend_metro: "Metrópole — NÃO elegível",
    },
    tracker: {
      title: "O meu tracker 88 dias",
      sub: "Carrega os teus recibos OU adiciona períodos manualmente. Validamos cada um automaticamente.",
      visa_select: "Para que visto estás a trabalhar?",
      target_select: "Objetivo",
      target_88: "2° WHV · 88 dias",
      target_179: "3° WHV · 179 dias",
      upload_title: "Carregar recibo (PDF)",
      upload_sub: "Extraímos datas, empregador e local automaticamente. Os ficheiros ficam no teu navegador.",
      upload_btn: "Carregar recibo",
      uploading: "A extrair dados…",
      add_manual: "Ou adiciona um período manualmente",
      manual_employer: "Nome do empregador",
      manual_postcode: "Código postal do local",
      manual_industry: "Indústria",
      manual_start: "Data início",
      manual_end: "Data fim",
      manual_add: "Adicionar período",
      manual_contract: "Tipo de contrato",
      manual_days_worked: "Dias fisicamente trabalhados",
      manual_days_worked_hint: "Conta apenas dias com turno completo. Sem meios-dias.",
      manual_hours_worked: "Horas totais no recibo",
      manual_hours_worked_hint: "Divididas por 7h/dia para calcular dias equivalentes.",
      manual_days_per_week: "Dias trabalhados por semana (segundo contrato)",
      manual_days_per_week_hint: "5 dias/semana no contrato = 7 dias contados (fins-de-semana incluídos).",
      manual_hourly_rate: "Tarifa horária ($/h)",
      manual_hourly_rate_hint: "Usada para detetar pagamento insuficiente.",
      contract_casual_desc: "Apenas dias físicos",
      contract_part_time_desc: "Calculado a partir das horas totais",
      contract_piece_rate_desc: "Pago ao kilo/caixa — apenas dias físicos",
      contract_fulltime_desc: "Dias de descanso incluídos",
      empty_title: "Sem períodos ainda",
      empty_sub: "Carrega um recibo ou adiciona um período manualmente.",
      progress_label: "Dias elegíveis totais",
      progress_title: "O teu progresso de 88 dias",
      progress_intro: "Apenas os períodos <b>validados</b> contam para o teu visto. Completa as localizações em falta para desbloquear mais dias.",
      stat_validated: "Validados",
      stat_to_complete: "Por completar",
      stat_rejected: "Rejeitados",
      stat_days: "dias",
      remaining: "Restantes",
      complete: "Conseguiste!",
      export_hint: "Descarrega um PDF para juntar à tua candidatura de visto. Adiciona um recibo de vencimento por período.",
      th_period: "Período",
      th_days: "Dias",
      th_employer: "Empregador",
      th_location: "Local",
      th_industry: "Indústria",
      th_status: "Estado",
      th_actions: "",
      delete: "Eliminar",
      eligible: "Elegível",
      not_eligible: "Não elegível",
      location_required: "Localização necessária",
      choose_location: "Escolher localização",
      change_location: "Alterar localização",
      location_missing_hint: "Procura uma cidade, código postal ou região",
      export_btn: "Exportar PDF prova (para Imigração)",
      payslip_parsed: "Recibo analisado com sucesso",
      payslip_error: "Não foi possível ler este recibo. Tenta outro PDF ou adiciona manualmente.",
      payslip_missing_postcode: "Código postal não detetado. Por favor confirma:",
      wage_warning_title: "Pagamento insuficiente detetado",
      wage_warning_body: "Declaraste ${rate}/h mas o mínimo legal é ${minimum}/h. Trabalho mal pago pode causar recusa de visto — verifica o teu Award e o teu empregador.",
      rules_title: "Regras oficiais de cálculo",
      rules_link: "Como conta a Imigração os meus dias?",
    },
  },
};

// Contract type labels (separate to avoid bloating each lang block)
export const CONTRACT_LABELS = {
  en: {
    casual: "Casual",
    part_time: "Part-time / Hourly",
    piece_rate: "Piece rate",
    fulltime: "Full-time contract",
  },
  fr: {
    casual: "Casual",
    part_time: "Temps partiel / Heures",
    piece_rate: "Au rendement",
    fulltime: "Temps plein",
  },
  de: { casual: "Casual", part_time: "Teilzeit / Stunden", piece_rate: "Akkordlohn", fulltime: "Vollzeit-Vertrag" },
  it: { casual: "Casual", part_time: "Part-time / Ore", piece_rate: "A cottimo", fulltime: "Contratto full-time" },
  es: { casual: "Casual", part_time: "Part-time / Horas", piece_rate: "A destajo", fulltime: "Contrato tiempo completo" },
  pt: { casual: "Casual", part_time: "Part-time / Horas", piece_rate: "Por produção", fulltime: "Contrato tempo integral" },
};

// Official rules summary shown in expandable panel
export const OFFICIAL_RULES = {
  en: {
    title: "How Immigration counts your days",
    casual: "Casual & Part-time — hours per week → days counted:",
    fulltime: "Full-time contract — days worked → days counted (rest days included):",
    table_hours: [
      ["35.25h+ / week", "7 days"],
      ["28.25 – 35h", "6 days"],
      ["21.25 – 28h", "5 days"],
      ["14.25 – 21h", "4 days"],
      ["7.25 – 14h", "3 days"],
      ["4 – 7h", "1 day"],
      ["< 4h", "0 days"],
    ],
    table_full: [
      ["5–7 days / week", "7 days counted"],
      ["4 days / week", "4 days counted"],
      ["3 days / week", "3 days counted"],
    ],
    warning: "If unsure, use Casual mode — it's the safest method to avoid visa refusal.",
  },
  fr: {
    title: "Comment l'Immigration compte tes jours",
    casual: "Casual & Part-time — heures par semaine → jours comptés :",
    fulltime: "Temps plein contractuel — jours travaillés → jours comptés (repos inclus) :",
    table_hours: [
      ["35,25h+ / sem", "7 jours"],
      ["28,25 – 35h", "6 jours"],
      ["21,25 – 28h", "5 jours"],
      ["14,25 – 21h", "4 jours"],
      ["7,25 – 14h", "3 jours"],
      ["4 – 7h", "1 jour"],
      ["< 4h", "0 jour"],
    ],
    table_full: [
      ["5–7 jours / sem", "7 jours comptés"],
      ["4 jours / sem", "4 jours comptés"],
      ["3 jours / sem", "3 jours comptés"],
    ],
    warning: "En cas de doute, utilise le mode Casual — c'est la méthode la plus sûre pour éviter un refus de visa.",
  },
  de: {
    title: "Wie Immigration deine Tage zählt",
    casual: "Casual & Teilzeit — Stunden pro Woche → gezählte Tage:",
    fulltime: "Vollzeit-Vertrag — Arbeitstage → gezählte Tage (Ruhetage inklusive):",
    table_hours: [
      ["35,25h+ / Woche", "7 Tage"],
      ["28,25 – 35h", "6 Tage"],
      ["21,25 – 28h", "5 Tage"],
      ["14,25 – 21h", "4 Tage"],
      ["7,25 – 14h", "3 Tage"],
      ["4 – 7h", "1 Tag"],
      ["< 4h", "0 Tage"],
    ],
    table_full: [
      ["5–7 Tage / Woche", "7 Tage gezählt"],
      ["4 Tage / Woche", "4 Tage gezählt"],
      ["3 Tage / Woche", "3 Tage gezählt"],
    ],
    warning: "Im Zweifelsfall verwende den Casual-Modus — die sicherste Methode, um eine Visumablehnung zu vermeiden.",
  },
  it: {
    title: "Come Immigration conta i tuoi giorni",
    casual: "Casual & Part-time — ore per settimana → giorni contati:",
    fulltime: "Contratto full-time — giorni lavorati → giorni contati (riposi inclusi):",
    table_hours: [
      ["35,25h+ / sett", "7 giorni"],
      ["28,25 – 35h", "6 giorni"],
      ["21,25 – 28h", "5 giorni"],
      ["14,25 – 21h", "4 giorni"],
      ["7,25 – 14h", "3 giorni"],
      ["4 – 7h", "1 giorno"],
      ["< 4h", "0 giorni"],
    ],
    table_full: [
      ["5–7 giorni / sett", "7 giorni contati"],
      ["4 giorni / sett", "4 giorni contati"],
      ["3 giorni / sett", "3 giorni contati"],
    ],
    warning: "In caso di dubbio, usa la modalità Casual — è il metodo più sicuro per evitare un rifiuto del visto.",
  },
  es: {
    title: "Cómo cuenta Inmigración tus días",
    casual: "Casual & Part-time — horas por semana → días contados:",
    fulltime: "Contrato tiempo completo — días trabajados → días contados (descansos incluidos):",
    table_hours: [
      ["35,25h+ / sem", "7 días"],
      ["28,25 – 35h", "6 días"],
      ["21,25 – 28h", "5 días"],
      ["14,25 – 21h", "4 días"],
      ["7,25 – 14h", "3 días"],
      ["4 – 7h", "1 día"],
      ["< 4h", "0 días"],
    ],
    table_full: [
      ["5–7 días / sem", "7 días contados"],
      ["4 días / sem", "4 días contados"],
      ["3 días / sem", "3 días contados"],
    ],
    warning: "Si tienes dudas, usa el modo Casual — es el método más seguro para evitar un rechazo de visa.",
  },
  pt: {
    title: "Como a Imigração conta os teus dias",
    casual: "Casual & Part-time — horas por semana → dias contados:",
    fulltime: "Contrato tempo integral — dias trabalhados → dias contados (descansos incluídos):",
    table_hours: [
      ["35,25h+ / sem", "7 dias"],
      ["28,25 – 35h", "6 dias"],
      ["21,25 – 28h", "5 dias"],
      ["14,25 – 21h", "4 dias"],
      ["7,25 – 14h", "3 dias"],
      ["4 – 7h", "1 dia"],
      ["< 4h", "0 dias"],
    ],
    table_full: [
      ["5–7 dias / sem", "7 dias contados"],
      ["4 dias / sem", "4 dias contados"],
      ["3 dias / sem", "3 dias contados"],
    ],
    warning: "Em caso de dúvida, usa o modo Casual — é o método mais seguro para evitar uma recusa de visto.",
  },
};

// Fallback to English for other languages for now
export function getVisaDaysT(lang) {
  return visaDaysI18n[lang] || visaDaysI18n.en;
}
